import React from 'react';
import { Card, CardContent, CardHeader } from '../ui/card';
import { Loader2 } from 'lucide-react';
import { renderEmphasis } from './formatEmphasis';

const LABEL_PREFIX = /^\s*(what this means|lo que esto significa|qué significa esto)\s*:?\s*/i;

/** Live-rendering turn while the Companion streams its explanation. */
const StreamingTurn = ({ language, question, text, messagesEndRef }) => {
  const es = language === 'es';
  const shown = (text || '').replace(LABEL_PREFIX, '');
  return (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="companion-streaming-turn">
      <div className="flex justify-end" data-testid="companion-user-question">
        <div className="max-w-[85%] rounded-2xl rounded-tr-sm bg-purple-600 text-white px-4 py-2 text-sm shadow">
          {question}
        </div>
      </div>
      <Card className="shadow-md">
        <CardHeader className="pb-3">
          <h3 className="text-sm font-semibold text-slate-700 dark:text-slate-300 flex items-center gap-2">
            <span>💡</span>
            {es ? 'Qué significa esto' : 'What this means'}
          </h3>
        </CardHeader>
        <CardContent>
          {shown ? (
            <p className="text-base text-slate-700 dark:text-slate-300 leading-relaxed" data-testid="companion-streaming-text">
              {renderEmphasis(shown)}
              <span className="inline-block w-[2px] h-4 ml-0.5 align-middle bg-purple-600 animate-pulse" />
            </p>
          ) : (
            <div className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400" data-testid="companion-thinking">
              {[0, 150, 300].map((d) => (
                <span key={d} className="inline-block w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: `${d}ms` }} />
              ))}
              <span className="ml-1">{es ? 'Lumera está pensando…' : 'Lumera is thinking…'}</span>
            </div>
          )}
        </CardContent>
      </Card>
      {shown && (
        <p className="flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400" data-testid="companion-gathering-resources">
          <Loader2 className="w-3.5 h-3.5 animate-spin" />
          {es ? 'Reuniendo escrituras y recursos…' : 'Gathering scripture & resources…'}
        </p>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default StreamingTurn;
